











































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  getBiaoqianList,
  saveBiaoqianList,
  GetPatientAllTongue,
  GetTongueDetail,
  SaveTongueDetail,
} from "@/request/research";
import PicCanvas from "./components/pic-canvas.vue";
import Shezhi from "./components/shezhi.vue";
import Shetai from "./components/shetai.vue";
import Luomai from "./components/luomai.vue";
import Fenge from "./components/fenge.vue";
@Component({
  components: {
    PicCanvas,
    Shezhi,
    Shetai,
    Fenge,
    Luomai,
  },
})
export default class IdrTongueBiaozhu extends Vue {
  private projectId: any = "";
  private tongueId: any = "";
  private options: any = {};
  private currentPicSrc: any = "";
  private tongue: any = {
    patient_id: "",
    舌象照片: {},
    轨迹: {},
  };
  private tongues: any[] = [];
  private model: any = "";
  private picType: any = "origin";
  private cPart: any = "望舌质";
  private ifShowBidui: boolean = false;
  private loaded: boolean = false;
  private ifOpenFenge: boolean = false;
  private kuankuanbiHelp: boolean = false;
  private labels: any = [];
  private ifShowAddLabel: boolean = false;
  private tempLabels: any[] = [];
  private get picCanvas() {
    return this.$refs.picCanvas as any;
  }
  @Watch("$route.query", { immediate: true, deep: true })
  private queryChange() {
    this.tongueId = this.$route.query.tongue_id;
    this.projectId = this.$route.query.project_id;
    if (this.$route.query.pType) {
      this.cPart = this.$route.query.pType;
    }
    this.fetchDetail().then(() => {
      this.fetchPatientAllTongue();
      if (this.$route.query.part) {
        switch (this.$route.query.part) {
          case "几何":
            // (this.$refs.sheti as any).tezhengbiaozhuScrollToView();
            break;
          case "分组":
            this.changePart("分组");
            break;
        }
      }
    });
  }
  private update(e: any) {
    this.tongue = e;
    this.$forceUpdate();
  }
  /**
   * @description 跳转智能比对
   */
  private jumpBidui() {
    localStorage.setItem("selectedTongues", JSON.stringify([this.tongue]));
    this.$router.push("/main/research/tongue/bidui-list");
  }
  /**
   * @description 保存
   */
  private save() {
    const params: any = JSON.parse(JSON.stringify(this.tongue));
    SaveTongueDetail(this, params).then((data: any) => {
      this.$message.success("标注成功");
    });
  }
  /**
   * @description 获得该患者的全部舌图
   */
  private fetchPatientAllTongue() {
    const params: any = {
      params: {
        patient_id: this.tongue.patient_id,
        project_id: this.projectId,
      },
    };
    GetPatientAllTongue(this, params).then((data: any) => {
      this.tongues = data;
    });
  }
  /**
   * @description 获得详情
   */
  private fetchDetail() {
    this.loaded = false;
    return new Promise((resolve, reject) => {
      const params: any = {
        params: {
          tongue_id: this.tongueId,
        },
      };
      GetTongueDetail(this, params)
        .then((data: any) => {
          this.tongue = data;
          this.currentPicSrc = this.tongue["舌象照片"]["舌面分割前图片"];
          this.loaded = true;
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 返回列表
   */
  private backList() {
    this.$router.push("/main/research/tongue/list");
  }
  /**
   * @description 跳转舌图预览
   */
  private jumpTonguePreview() {
    const params: any = JSON.parse(JSON.stringify(this.tongue));
    SaveTongueDetail(this, params).then((data: any) => {
      this.$router.push({
        path: "/main/research/tongue/report-preview",
        query: {
          tongue_id: this.tongue.tongue_id,
        },
      });
    });
  }
  /**
   * @description 切换同一个患者的其他舌图
   */
  private changeTongue(tongue: any) {
    this.$router.push({
      path: "/main/research/tongue/biaozhu",
      query: {
        tongue_id: tongue.tongue_id,
        project_id: this.projectId,
      },
    });
  }
  /**
   * @description 切换展示的图片
   */
  private changeCurrentPic(src: any, model: any) {
    this.currentPicSrc = src;
    this.picType = model;
  }
  // 图像标注
  /**
   * @description 局部舌色
   */
  private jubushese() {
    this.model = "局部舌色";
    this.cPart = "望舌体";
    this.$nextTick().then(() => {
      (this.$refs.sheti as any).jubusheseScrollToView();
    });
    this.picCanvas.jubushese();
  }
  /**
   * @description 删除局部舌色
   */
  private deleteJubushese() {
    this.picCanvas.deleteJubushese();
  }
  /**
   * @description 局部苔色
   */
  private jubutaise() {
    this.model = "局部苔色";
    this.cPart = "望舌苔";
    this.$nextTick().then(() => {
      (this.$refs.shetai as any).jubutaiseScrollToView();
    });
    this.picCanvas.jubutaise();
  }
  /**
   * @description 删除局部苔色
   */
  private deleteJubutaise() {
    this.picCanvas.deleteJubutaise();
  }

  /**
   * @description 舌上红点
   */
  private sheshanghongdian() {
    this.model = "舌上红点";
    this.cPart = "望舌体";
    // this.$nextTick().then(() => {
    //   (this.$refs.sheti as any).tezhengbiaozhuScrollToView();
    // });
    this.picCanvas.sheshanghongdian();
  }
  /**
   * @description 删除舌上红点
   */
  private deleteSheshanghongdian() {
    this.picCanvas.deleteSheshanghongdian();
  }
  /**
   * @description 瘀斑
   */
  private yuban() {
    this.model = "瘀斑";
    this.picCanvas.yuban();
  }
  /**
   * @description 删除某个瘀斑
   */
  private deleteYuban(index: any) {
    this.picCanvas.deleteYuban(index);
  }
  /**
   * @description 齿痕
   */
  private chihen() {
    this.model = "齿痕";
    this.picCanvas.chihen();
  }
  /**
   * @description 删除某个齿痕
   */
  private deleteChihen(index: any) {
    this.picCanvas.deleteChihen(index);
  }
  /**
   * @description 裂纹
   */
  private liewen() {
    this.model = "裂纹";
    this.picCanvas.liewen();
  }
  /**
   * @description 删除某个裂纹
   */
  private deleteLiewen(index: any) {
    this.picCanvas.deleteLiewen(index);
  }
  /**
   * @description 胖瘦
   */
  private pangshou() {
    this.model = "胖瘦";
    // this.cPart = "望舌体";
    if (!this.tongue["轨迹"]["胖瘦"]) {
      this.tongue["轨迹"]["胖瘦"] = {
        嘴角间距: {},
        舌间距: {},
      };
    }
    // this.$nextTick().then(() => {
    //   (this.$refs.sheti as any).tezhengbiaozhuScrollToView();
    // });
    this.picCanvas.pangshou();
    if (this.kuankuanbiHelp === false && this.picType === "origin") {
      this.$confirm(
        "宽宽比是指嘴角间距和舌两边距离的比值，您可以先在嘴角画一条线，再在舌两边画一条线，系统就会自动得出宽宽比",
        {
          showCancelButton: false,
        }
      );
    }
    this.kuankuanbiHelp = true;
  }
  /**
   * @description 删除胖瘦的某条线
   */
  private deletePangshou(part: any) {
    this.picCanvas.deletePangshou(part);
  }
  /**
   * @description 苔质
   */
  private taizhi() {
    this.model = "苔质";
    this.picCanvas.taizhi();
  }
  /**
   * @description 删除某个苔质
   */
  private deleteTaizhi(index: any) {
    this.picCanvas.deleteTaizhi(index);
  }
  /**
   * @description 剥落
   */
  private boluo() {
    this.model = "剥落";
    this.picCanvas.boluo();
  }
  /**
   * @description 删除某个剥落
   */
  private deleteBoluo(index: any) {
    this.picCanvas.deleteBoluo(index);
  }
  /**
   * @description 局部舌苔
   */
  private jubushetai() {
    this.model = "舌苔局部放大图";
    this.picCanvas.jubushetai();
  }
  /**
   * @description 删除某个舌苔局部放大图
   */
  private deleteJubushetai(index: any) {
    this.picCanvas.deleteJubushetai(index);
  }
  /**
   * @description 点刺
   */
  private dianci() {
    this.model = "点刺";
    this.picCanvas.dianci();
  }
  /**
   * @description 删除某个点刺
   */
  private deleteDianci(index: any) {
    this.picCanvas.deleteDianci(index);
  }
  /**
   * @description 舌态
   */
  private shetai() {
    this.model = "舌态";
    this.picCanvas.shetai();
  }
  /**
   * @description 删除某个舌态
   */
  private deleteShetai(index: any) {
    this.picCanvas.deleteShetai(index);
  }
  /**
   * @description 瘀点
   */
  private yudian() {
    this.model = "瘀点";
    this.picCanvas.yudian();
  }
  /**
   * @description 删除某个瘀点
   */
  private deleteYudian(index: any) {
    this.picCanvas.deleteYudian(index);
  }
  /**
   * @description 打开分割弹窗
   */
  private fenge() {
    this.ifOpenFenge = true;
  }
  // 图像操作
  /**
   * @description 移动
   */
  private yidong() {
    this.model = "移动";
    this.picCanvas.yidong();
  }
  /**
   * @description 缩放
   */
  private suofang() {
    this.model = "缩放";
    this.picCanvas.suofang();
  }
  /**
   * @description 放大镜
   */
  private fangdajing() {
    this.model = "放大镜";
    this.picCanvas.fangdajing();
    this.cPart = "望舌苔";
    this.$nextTick().then(() => {
      (this.$refs.shetai as any).jubushetaiScrollToView();
    });
  }
  /**
   * @description 旋转
   */
  private xuanzhuan() {
    this.model = "旋转";
    this.picCanvas.xuanzhuan();
  }
  /**
   * @description 截屏
   */
  private jieping() {
    this.model = "截屏";
    this.picCanvas.jieping();
  }
  /**
   * @description 还原
   */
  private huanyuan() {
    this.model = "还原";
    this.picCanvas.huanyuan();
  }
  /**
   * @description 改变model
   */
  private modelChange(model: any) {
    this.model = model;
  }
  /**
   * @description 切换显示的部分
   */
  private changePart(part: any) {
    this.cPart = part;
  }
  /**
   * @description 获得可选的标签列表
   */
  private fetchBiaoqianList() {
    return new Promise((resolve, reject) => {
      getBiaoqianList(this)
        .then((data: any) => {
          this.labels = data;
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * 当前标签是否被选中
   */
  private getHas(name: any) {
    let result = false;
    if (this.tongue["分组标签"] && this.tongue["分组标签"].length > 0) {
      this.tongue["分组标签"].forEach((ele: any) => {
        if (ele["名称"] === name) {
          result = true;
        }
      });
    }
    return result;
  }
  /**
   * @description 删除当前舌图标签
   */
  private delOpt(i: any) {
    this.tongue["分组标签"].splice(i, 1);
  }
  /**
   * @description 选择舌图标签
   */
  private selOne(item: any) {
    if (this.getHas(item["名称"])) {
      return;
    }
    this.tongue["分组标签"].push(item);
  }
  /**
   * @description 打开添加标签弹窗
   */
  private openAddLabel() {
    this.tempLabels = JSON.parse(JSON.stringify(this.labels));
    if (this.tempLabels.length === 0) {
      this.$set(this.tempLabels, "0", { 名称: "" });
    }
    this.ifShowAddLabel = true;
  }
  /**
   * @description 关闭弹窗
   */
  private closeAddLabel() {
    this.ifShowAddLabel = false;
  }
  /**
   * @description 刷新页面
   */
  private refresh() {
    this.fetchBiaoqianList().then(() => {
      this.filterSelectedLables();
    });
  }
  /**
   * @description 根据新的标签列表，筛选已选标签
   */
  private filterSelectedLables() {
    this.tongue["分组标签"].forEach((item: any, index: any) => {
      this.labels.forEach((i: any) => {
        if (i.id === item.id) {
          this.tongue["分组标签"].splice(index, 1);
        }
      });
    });
  }
  /**
   * @description 添加临时标签
   */
  private addLabel() {
    this.tempLabels.unshift({ 名称: "" });
  }
  /**
   * @description 删除一个标签
   */
  private deleteLabel(index: any) {
    if (this.tempLabels.length === 1) {
      this.tempLabels = [{ 名称: "" }];
    } else {
      this.tempLabels.splice(index, 1);
    }
  }
  /**
   * @description 保存对标签的修改
   */
  private saveAddedLabel() {
    const params: any = {
      tags: this.tempLabels,
    };
    saveBiaoqianList(this, params).then(() => {
      this.$message.success("修改成功");
      this.ifShowAddLabel = false;
      this.tempLabels = [];
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchBiaoqianList();
  }
}
